export default {
  SET_USER_INFO(state, payload) {
    state.userInfo = payload;
  },
  SET_CLAUSES(state, payload) {
    state.clauses = payload;
  },
  SET_ACCESS_TOKEN(state, payload) {
    state.accessToken = payload;
  },
  CLEAR_USER_INFO(state) {
    state.userInfo = {};
  },
};
